module.exports = {
      id: "plus-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#plus",
      toString: function () {
        return this.url;
      }
    }